import { render, staticRenderFns } from "./ShopWorkdaysData.vue?vue&type=template&id=eae24210&"
import script from "./ShopWorkdaysData.vue?vue&type=script&lang=js&"
export * from "./ShopWorkdaysData.vue?vue&type=script&lang=js&"
import style0 from "./ShopWorkdaysData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports